export default "__VITE_ASSET__DKgv06ps__"